import React from 'react';
import toLower from 'lodash/toLower';

import { useTranslation } from '@lyearn/i18n';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import AttachCategoriesModal from '@/modules/corporate/modules/discover/components/AttachCategoriesModal';

import { DialogProps } from '../../types';

const AttachCategories: React.FC<DialogProps> = ({ content, onSubmit, onClose }) => {
  const { t } = useTranslation();
  const { isLocalizedContent } = content;
  const contentType = toLower(t(RESOURCE_TYPE_LABEL_CONFIG[content.type].title));

  const getSnackbarMessage = () =>
    content.categoryIds?.length
      ? t('Discover:Category.Admin.CategoriesUpdatedForThisContent', { contentType })
      : t('Discover:Category.Admin.CategoriesAddedToThisContent', { contentType });

  const onSubmitHandler = (categoryIds: string[] | undefined) => {
    onSubmit?.({ categoryIds: { set: categoryIds || [] } }, { message: getSnackbarMessage() });
  };

  return (
    <AttachCategoriesModal
      contentType={contentType}
      readonly={isLocalizedContent}
      selectedCategoryIds={content.categoryIds}
      subWorkspaceIds={content.subWorkspaces || []}
      onAttach={onSubmitHandler}
      onClose={onClose}
    />
  );
};

export default AttachCategories;
